module.exports = __webpack_public_path__ + "static/media/henk_hanneke.83a8be51.jpg";